import typography from "./typography";
import color from "./color";

export default {
    typography,
    color,
};
